import React from 'react';

export default function MaintenancePage() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center px-4">
      <div className="max-w-2xl w-full bg-white rounded-2xl shadow-2xl p-8 md:p-12 text-center">
        {/* Logo/Icon */}
        <div className="flex justify-center mb-6">
          <div className="w-20 h-20 bg-blue-600 rounded-2xl flex items-center justify-center shadow-lg">
            <svg className="w-12 h-12 text-white" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 4.75L19.25 9L12 13.25L4.75 9L12 4.75Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M9.25 11.5L4.75 14L12 18.25L19.25 14L14.75 11.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </div>
        </div>

        {/* Brand Name */}
        <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
          ArcAttend
        </h1>

        {/* Maintenance Message */}
        <div className="mb-8">
          
          <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-4">
            We'll be right back!
          </h2>
          
          <p className="text-lg text-gray-600 mb-2">
            ArcAttend is currently undergoing scheduled maintenance.
          </p>
          
          <p className="text-gray-500">
            We're working hard to improve your experience. Please check back shortly.
          </p>
        </div>


        {/* Estimated Time */}
        <div className="bg-blue-50 rounded-lg p-4 mb-6">
          <p className="text-sm text-blue-800">
            <span className="font-semibold">Estimated completion:</span> We'll be back online as soon as possible
          </p>
        </div>

        {/* Contact Info */}
        <div className="border-t border-gray-200 pt-6">
          <p className="text-sm text-gray-500">
            Need urgent assistance?{' '}
            <a href="mailto:team@arczen.com" className="text-blue-600 hover:text-blue-700 font-medium underline">
              Contact Support
            </a>
          </p>
        </div>

        {/* Decorative Elements */}
        <div className="mt-8 flex justify-center gap-2">
          <div className="w-2 h-2 bg-blue-400 rounded-full animate-bounce" style={{ animationDelay: '0ms' }}></div>
          <div className="w-2 h-2 bg-blue-500 rounded-full animate-bounce" style={{ animationDelay: '150ms' }}></div>
          <div className="w-2 h-2 bg-blue-600 rounded-full animate-bounce" style={{ animationDelay: '300ms' }}></div>
        </div>
      </div>
    </div>
  );
}
